import { FC } from 'react'
import { differenceInMinutes } from 'date-fns'

import { Alert } from 'ui'
import { Parse } from 'services/Dates'
import { t } from 'translations'

type Props = {
  end: string | Date
  start: string | Date
}

const _16_HOURS_IN_MINUTES = 960

const IsShiftOver16Hours: FC<Props> = ({ end, start }) => {
  if (!start || !end) return null
  const amountOfMinutesInShift = differenceInMinutes(Parse(end), Parse(start))
  if (amountOfMinutesInShift > _16_HOURS_IN_MINUTES) return <Alert variant="warning">{t('manager.schedule.SHIFT_MORE_THEN_16HOURS')}</Alert>

  return null
}

export default IsShiftOver16Hours
